import React, { useState } from 'react';
import { MapPinIcon, ChevronDownIcon } from 'lucide-react';
const counties = [{
  name: 'Mecosta County',
  cities: ['Big Rapids', 'Stanwood', 'Barryton', 'Morley', 'Remus', 'Rodney', 'Canadian Lakes']
}, {
  name: 'Osceola County',
  cities: ['Reed City', 'Evart', 'Marion', 'Le Roy', 'Hersey', 'Sears', 'Tustin']
}, {
  name: 'Newaygo County',
  cities: ['Newaygo', 'White Cloud', 'Fremont', 'Grant', 'Hesperia', 'Shelby', 'Croton']
}, {
  name: 'Montcalm County',
  cities: ['Greenville', 'Stanton', 'Carson City', 'Sheridan', 'Lakeview', 'Edmore', 'Entrican']
}];
export function ServiceArea() {
  const [openCounty, setOpenCounty] = useState<number | null>(null);
  const toggleCounty = (index: number) => {
    setOpenCounty(openCounty === index ? null : index);
  };
  return <section className="relative py-20 min-h-[600px]" data-id="element-137">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/pJZAYiL8FDX9ouMdmssoMD/image.png')"
    }} data-id="element-138">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-139"></div>
      </div>
      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-141">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-142">
            Our Service Area
          </h2>
          <p className="text-xl text-white" data-id="element-143">
            Proudly serving Mecosta, Osceola, Newaygo, and Montcalm Counties.
          </p>
        </div>
        {/* Counties Display */}
        <div className="max-w-5xl mx-auto" data-id="element-144">
          <div className="bg-white bg-opacity-95 rounded-lg p-8 md:p-12 shadow-2xl" data-id="element-145">
            {/* Michigan Header */}
            <div className="text-center mb-8" data-id="element-146">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-147">
                Michigan
              </h3>
              <div className="w-24 h-1 bg-[#E41C1C] mx-auto" data-id="element-148"></div>
            </div>
            {/* Counties Grid */}
            <div className="grid md:grid-cols-2 gap-6" data-id="element-149">
              {counties.map((county, index) => <div key={index} className="bg-gray-50 rounded-lg shadow-md" data-id="element-150">
                  {/* County Header - Clickable */}
                  <button onClick={() => toggleCounty(index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-100 transition-colors rounded-lg" data-id="element-151">
                    <div className="flex items-center gap-4" data-id="element-152">
                      <div className="flex-shrink-0 w-12 h-12 bg-[#E41C1C] rounded-full flex items-center justify-center" data-id="element-153">
                        <MapPinIcon className="w-6 h-6 text-white" data-id="element-154" />
                      </div>
                      <p className="text-lg font-bold text-gray-900" data-id="element-155">
                        {county.name}
                      </p>
                    </div>
                    <ChevronDownIcon className={`w-5 h-5 text-gray-600 transition-transform ${openCounty === index ? 'rotate-180' : ''}`} data-id="element-156" />
                  </button>
                  {/* Cities Dropdown */}
                  {openCounty === index && <div className="px-6 pb-6" data-id="element-157">
                      <div className="border-t border-gray-200 pt-4" data-id="element-158">
                        <p className="text-sm font-semibold text-gray-600 mb-3" data-id="element-159">
                          Cities We Serve:
                        </p>
                        <ul className="grid grid-cols-2 gap-2" data-id="element-160">
                          {county.cities.map((city, cityIndex) => <li key={cityIndex} className="text-sm text-gray-700 flex items-center gap-2" data-id="element-161">
                              <div className="w-1.5 h-1.5 bg-[#E41C1C] rounded-full" data-id="element-162"></div>
                              {city}
                            </li>)}
                        </ul>
                      </div>
                    </div>}
                </div>)}
            </div>
            {/* Additional Info */}
            <div className="mt-8 text-center" data-id="element-163">
              <p className="text-gray-600" data-id="element-164">
                Not sure if we service your area?{' '}
                <a href="tel:231-796-2952" className="text-[#E41C1C] font-bold hover:underline" data-id="element-165">
                  Give us a call at 231-796-2952
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}